import { Injectable } from '@angular/core';
import * as Excel from "exceljs/dist/exceljs.min.js";
import * as FileSaver from 'file-saver';
import { DefaultService, BatteryReportByNode} from "@psnb/psnb-api";

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelPowersupplyPsinventorystateService {

  constructor(private powerSupplyService: DefaultService) { }


  public exportReportByPsinventoryExcelFile(telemetryDataVal,inspectionDataVal,batteryDataVal,json: any[], excelFileName: string) {
    const workbook = new Excel.Workbook;
    workbook.addWorksheet('PowerSupplyInventoryList');
    const sheet = workbook.getWorksheet(1);
    sheet.columns = this.getHeaders(telemetryDataVal,inspectionDataVal,batteryDataVal);
    sheet.addRows(json);
    sheet.eachRow(function (row, rowNumber) {
      row.eachCell({ includeEmpty: true }, function (cell) {
        if (rowNumber === 1) {
          sheet.getCell(cell.address.toString()).fill = {
            type: 'gradient', gradient: 'angle', degree: 0, stops: [
              { position: 0, color: { argb: 'd9f1fa' } },
              { position: 0.5, color: { argb: 'd9f1fa' } },
              { position: 1, color: { argb: 'd9f1fa' } }
            ]
          };
          sheet.getCell(cell.address.toString()).alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
          sheet.getCell(cell.address.toString()).border = { right: { style: 'thin' }, top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' } };
          sheet.getCell(cell.address.toString()).font = { name: 'Calibri', family: 2, size: 8, bold: 'true' };
        } else {
          sheet.getCell(cell.address.toString()).alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
          sheet.getCell(cell.address.toString()).font = { name: 'Calibri', family: 2, size: 8 };
          sheet.getCell(cell.address.toString()).border = { right: { style: 'thin' }, top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' } };
        }
      });
    });
    workbook.xlsx.writeBuffer().then(data => {
      const blob = new Blob([data], { type: EXCEL_TYPE });
      FileSaver.saveAs(blob, excelFileName + EXCEL_EXTENSION);
    })
    return false;
  }

  getHeaders(telemetryDataVal,inspectionDataVal,batteryDataVal) {


    let wchPowerSupplyId = 14;
    let wchRegionName = 15;
    let wchHeadendName = 15;
    let wchCommunityName = 18;
    let wchName = 15;
    let wchPowerSupplyName = 20;
    let wchIp = 20;
    let wchMacAddress = 20;
    let wchcmts = 25;
    let wchpreviousMacAddress = 20;
    let wchalertProfile = 30;
    let wchcontrollerCardType = 20;
    let wchhouseNumber = 10;
    let wchaddressLine1 =20;
    let wchcrossStreet = 20;
    let wchcity = 15;
    let wchstate = 15;
    let wchzipCode = 15;
    let wchlatitude = 15;
    let wchlongitude = 15;
    let wchpoleNumber = 10;
    let wchpowerCompany = 25;
    let wchPowerCompanyVendor = 21;
    let wchPowerCompanycontact = 21;
    let wchPowerCompanywebsite = 21;
    let wchteam = 15;
    let wchpowersNode = 15;
    let wchmeterNumber = 15;
    let wchmapNumber = 15;
    let wchNode2 = 10;
    let wchNode3 = 10;
    let wchNode4 = 10;
    let wchNode5 = 10;
    let wchNode6 = 10;
    let wchNode7 = 10;
    let wchNode8 = 10;
    let wchNode9 = 10;
    let wchNode10 = 10;
    let wchNode11 = 10;
    let wchNode12 = 10;
    let wchNode13 = 10;
    let wchNode14 = 10;
    let wchNode15 = 10;
    let wchbatteries = 20;
    let wchmiscellaneous = 20;
    let wchestimatedDesignedRuntime = 15;
    let wchstandByStatus = 25;
    let wchfeedsMultipleNodes = 10;
    let wchpowerSupplyNumber = 10;
    let wchnextGenNode = 15;
    let wchpowerSupplyType9360 = 18;
    let wchTransponderVendor = 18;
    let wchTransponderModel = 17;
    let wchPowerSupplyModel = 15;
    let wchoutputVoltageSpec = 20;
    let wchacInputVoltageSpec = 15;
    let wchcurrentAmpRatingSpec = 18;
    let wchcurrentAmpOutputUsed = 18;
    let wchbatteriesReplaced = 15;
    let wchbatteryBalancerString = 18;
    let wchaerialOrUg = 10;
    let wchegisName = 15;
    let wchfollowUpActionNeeded = 18;
    let wchmigration = 10;
    let wchnwtTeam = 10;
    let wchnitroCompletionDate = 15;
    let wchnitroReasonNotCompleted = 15;
    let wchpowerSupplyStatus = 15;
    let wchalarm = 10;
    let wchalarmType = 15;
    let wchpsScore = 15;
    let wchselfTestStatus = 20;
    let wchlastPolled = 15;
    let wchinputVoltage = 10;
    let wchoutputVoltage = 13;
    let wchtotalStringVoltage = 13;
    let wchtemperature = 10;
    let wchoutputCurrent1 = 13;
    let wchoutputCurrent2 = 13;
    let wchinverterStatus = 15;
    let wchfrequencyOut = 15;
    let wchbatteryBreakerTripped = 20;
    let wchbatteryTimeMins = 15;
    let wchpowerSupplyRevision = 10;
    let wchtransponderRevision = 15;
    let wchtransponderFirmware = 20;
    let wchtransponderBootFile = 15;
    let wchcableModemBootFile = 20;
    let wchpsSoftwareVersion = 20;


    let wchgeneratorSoftwareVersion = 15;
    let wchxm3SoftwareVersion = 15;
    let wchxm3SagCardFirmware = 15;
    let wchxm3AppCardFirmware = 15;
    let wchalphaPMCertificationReportLegacy = 15;
    let wchinspectionDate = 15;
    let wchtypeOfVisit = 15;
    let wchxocVerified = 15;
    let wchcleanEnclosure = 15;
    let wchtightenHardware = 15;
    let wchinspectConnectors = 15;
    let wchinspectProbes = 15;

    let wchmeterPanCondition = 15;
    let wchpowerCoRiserCondition = 15;
    let wchbatteryHeaterMatType = 15;
    let wchbatteryHeaterMatQuantity = 15;
    let wchenclosureSnowShield = 15;
    let wchinternalBreaker = 15;
    let wchserviceEntrance = 15;
    let wchreceptacleType = 15;

    let wchcheckSeizureAltBox = 15;
    let wchpowerSupplyIdLegible = 15;
    let wchcheckLampsLeds = 15;
    let wchcheckMagneticBreaker = 15;
    let wchvisualCabinetInspection = 15;
    let wchcabinetLocked = 15;
    let wchsecurityBarPresent = 15;
    let wchcheckGroundCabinet = 15;


    let wchBatteryString1Fused = 15;
    let wchBatteryString2Fused = 15;
    let wchBatteryString3Fused = 15;
    let wchBatteryString4Fused = 15;
    let wchtamperInstalledFunctioning = 15;
    let wchcheckLaps = 15;
    let wchcabinetVendor = 15;
    let wchcabinetBatteryCapacity = 20;


    let wchcheckOperatingLights = 15;
    let wchstandByOperation = 15;
    let wchremoteStandbyOperation2 = 15;
    let wchremoteStandbyOperation3 = 15;
    let wchremoteStandbyOperation4 = 15;
    let wchremoteStandbyOperation5 = 15;
    let wchfollowUpNeeded = 15;
    let wchinputSurgeArrestor = 15;


    let wchoutputSurgeArrestor = 15;
    let wchcoaxTvssPresent = 15;
    let wchacIndicatorGreenLight = 15;
    let wchlocalRemoteIndicator = 15;
    let wchcommTech = 15;


    //battery
    let wchbatteryReplacementDate = 15;
    let wchdateEntered = 20;
    let wchtemperatures = 15;
    let wchspecialLocationDetails = 15;
    let wchshowActualLocation = 15;
    let wchtype11 = 15;
    let wchtype12 = 15;
    let wchtype13 = 15;
    let wchtype14 = 15;
    let wchtype21 = 15;
    let wchtype22 = 15;
    let wchtype23 = 15;
    let wchtype24 = 15;
    let wchtype31 = 15;
    let wchtype32 = 15;
    let wchtype33 = 15;
    let wchtype34 = 15;
    let wchstring1Battery1DateCode = 15;
    let wchstring1Battery2DateCode = 15;
    let wchstring1Battery3DateCode = 15;
    let wchstring1Battery4DateCode = 15;
    let wchstring2Battery1DateCode = 15;
    let wchstring2Battery2DateCode = 15;
    let wchstring2Battery3DateCode = 15;
    let wchstring2Battery4DateCode = 15;
    let wchstring3Battery1DateCode = 15;
    let wchstring3Battery2DateCode = 15;
    let wchstring3Battery3DateCode = 15;
    let wchstring3Battery4DateCode = 15;
    let wchinstallDate11 = 15;
    let wchinstallDate12 = 15;
    let wchinstallDate13 = 15;
    let wchinstallDate14 = 15;
    let wchinstallDate21 = 15;
    let wchinstallDate22 = 15;
    let wchinstallDate23 = 15;
    let wchinstallDate24 = 15;
    let wchinstallDate31 = 15;
    let wchinstallDate32 = 15;
    let wchinstallDate33 = 15;
    let wchinstallDate34 = 15;
    let wchvoltage11 = 15;
    let wchvoltage12 = 15;
    let wchvoltage13 = 15;
    let wchvoltage14 = 15;
    let wchvoltage21 = 15;
    let wchvoltage22 = 15;
    let wchvoltage23 = 15;
    let wchvoltage24 = 15;
    let wchvoltage31 = 15;
    let wchvoltage32 = 15;
    let wchvoltage33 = 15;
    let wchvoltage34 = 15;

    let wchtestStartStringVoltage = 20;
    let wchtestEndStringVoltage = 20;
    let wchoutputPower = 20;
    let wchs1b1Voltage = 20;
    let wchs1b2Voltage = 20;
    let wchs1b3Voltage = 20;
    let wchs1b4Voltage = 20;
    let wchs2b1Voltage = 20;
    let wchs2b2Voltage = 20;
    let wchs2b3Voltage = 20;
    let wchs2b4Voltage = 20;
    let wchs3b1Voltage = 20;
    let wchs3b2Voltage = 20;
    let wchs3b3Voltage = 20;
    let wchs3b4Voltage = 20;
    let wchs4b1Voltage = 20;
    let wchs4b2Voltage = 20;
    let wchs4b3Voltage = 20;
    let wchs4b4Voltage = 20;
    let wchVisitStatus=25;
    let wchFollowUpReason=33;
    let wchBusinessPartnerRestriction=20;
    let wchhierarchyPathLabels=33;

    const mandatoryarr= [{ header: 'PowerSupplyId', key: 'powerSupplyId', width: wchPowerSupplyId },
    { header: 'RegionName', key: 'regionName', width: wchRegionName },
    { header: 'HeadendName', key: 'headendName', width: wchHeadendName },
    { header: 'CommunityName', key: 'communityName', width: wchCommunityName },
    { header: 'NodeName', key: 'node', width: wchName },
    { header: 'Hierarchy Path', key: 'hierarchyPathLabels', width: wchhierarchyPathLabels },
    { header: 'PowerSupplyName', key: 'powerSupplyName', width: wchPowerSupplyName },
    { header: 'IP', key: 'ipAddress', width: wchIp },
    { header: 'MacAddress', key: 'macAddress', width: wchMacAddress },
    { header: 'CMTS', key: 'cmts', width: wchcmts },
    { header: 'PreviousMacAddress', key: 'previousMacAddress', width: wchpreviousMacAddress },
    { header: 'AlertProfile', key: 'alertProfile', width: wchalertProfile },
    // { header: 'ControllerCardType', key: 'controllerCardType', width: wchcontrollerCardType },
    { header: 'HouseNumber', key: 'houseNumber', width: wchhouseNumber },
    { header: 'AddressLine1', key: 'addressLine1', width: wchaddressLine1 },
    { header: 'CrossStreet', key: 'crossStreet', width: wchcrossStreet },
    { header: 'City', key: 'city', width: wchcity },
    { header: 'State', key: 'state', width: wchstate },
    { header: 'ZipCode', key: 'zipCode', width: wchzipCode },
    { header: 'latitude', key: 'latitude', width: wchlatitude },
    { header: 'longitude', key: 'longitude', width: wchlongitude },
    { header: 'PoleNumber', key: 'poleNumber', width: wchpoleNumber },
    { header: 'PowerCompany', key: 'powerCompany', width: wchpowerCompany },
    { header: 'Power Company Contact', key: 'powerCompanyContactNumber', width: wchPowerCompanycontact },
    { header: 'Power Company Website', key: 'powerCompanyWebsite', width: wchPowerCompanywebsite },
    //{ header: 'Team', key: 'team', width: wchteam },
    { header: 'PowerCompanyAccountType', key: 'powerAccountType', width: wchpowerCompany },
    { header: 'PowersNode', key: 'powersNode', width: wchpowersNode },
    { header: 'MeterNumber', key: 'meterNumber', width: wchmeterNumber },
    { header: 'MapNumber', key: 'mapNumber', width: wchmapNumber },
    { header: 'Node2', key: 'node2', width: wchNode2 },
    { header: 'Node3', key: 'node3', width: wchNode3 },
    { header: 'Node4', key: 'node4', width: wchNode4 },
    { header: 'Node5', key: 'node5', width: wchNode5 },
    { header: 'Node6', key: 'node6', width: wchNode6 },
    { header: 'Node7', key: 'node7', width: wchNode7 },
    { header: 'Node8', key: 'node8', width: wchNode8 },
    { header: 'Node9', key: 'node9', width: wchNode9 },
    { header: 'Node10', key: 'node10', width: wchNode10 },
    { header: 'Node11', key: 'node11', width: wchNode11 },
    { header: 'Node12', key: 'node12', width: wchNode12 },
    { header: 'Node13', key: 'node13', width: wchNode13 },
    { header: 'Node14', key: 'node14', width: wchNode14 },
    { header: 'Node15', key: 'node15', width: wchNode15 },
    { header: 'Batteries', key: 'batteries', width: wchbatteries },
    { header: 'Miscellaneous', key: 'miscellaneous', width: wchmiscellaneous },
    { header: 'EstimatedDesignedRuntime', key: 'estimatedDesignedRuntime', width: wchestimatedDesignedRuntime },
    { header: 'StandByStatus', key: 'standByStatus', width: wchstandByStatus },
    { header: 'FeedsMultipleNodes', key: 'feedsMultipleNodes', width: wchfeedsMultipleNodes },
    { header: 'PowerSupplyNumber', key: 'powerSupplyNumber', width: wchpowerSupplyNumber },
    { header: 'NextGenNode', key: 'nextGenNode', width: wchnextGenNode },
    { header: 'PowerSupplyType9360', key: 'powerSupplyType9360', width: wchpowerSupplyType9360 },
    { header: 'TransponderVendor', key: 'transponderVendor', width: wchTransponderVendor },
    { header: 'TransponderModel', key: 'transponderModel', width: wchTransponderModel },
    { header: 'PowerSupplyModel', key: 'powerSupplyModel', width: wchPowerSupplyModel },
    { header: 'OutputVoltageSpec', key: 'outputVoltageSpec', width: wchoutputVoltageSpec },
    { header: 'AcInputVoltageSpec', key: 'acInputVoltageSpec', width: wchacInputVoltageSpec },
    { header: 'CurrentAmpRatingSpec', key: 'currentAmpRatingSpec', width: wchcurrentAmpRatingSpec },
    { header: 'CurrentAmpOutputUsed', key: 'currentAmpOutputUsed', width: wchcurrentAmpOutputUsed },
    { header: 'BatteriesReplaced', key: 'batteriesReplaced', width: wchbatteriesReplaced },
    { header: 'BatteryBalancerString', key: 'batteryBalancerString', width: wchbatteryBalancerString },
    { header: 'AerialOrUg', key: 'aerialOrUg', width: wchaerialOrUg },
    { header: 'EgisName', key: 'egisName', width: wchegisName },
    //{ header: 'FollowUpActionNeeded', key: 'followUpActionNeeded', width: wchfollowUpActionNeeded },
    //{ header: 'Migration', key: 'migration', width: wchmigration },

    { header: 'NWTTeam', key: 'nwtTeam', width: wchnwtTeam },

    { header: 'NitroCompletionDate', key: 'nitroCompletionDate', width: wchnitroCompletionDate },
    { header: 'BusinessPartnerRestriction', key: 'businessPartnerRestriction', width: wchBusinessPartnerRestriction }];
    //{ header: 'NitroReasonNotCompleted', key: 'nitroReasonNotCompleted', width: wchnitroReasonNotCompleted }];


    const telemetryarr = [{ header: 'PowerSupplyStatus', key: 'powerSupplyStatus', width: wchpowerSupplyStatus },
    { header: 'Alarm', key: 'alarm', width: wchalarm },
    { header: 'AlarmType', key: 'alarmType', width: wchalarmType },
    { header: 'PsScore', key: 'psScore', width: wchpsScore },
    { header: 'SelfTestStatus', key: 'selfTestStatus', width: wchselfTestStatus },
    { header: 'LastPolled', key: 'lastPolled', width: wchlastPolled },
    { header: 'InputVoltage', key: 'inputVoltage', width: wchinputVoltage },
    { header: 'OutputVoltage', key: 'outputVoltage', width: wchoutputVoltage },
    { header: 'TotalStringVoltage', key: 'totalStringVoltage', width: wchtotalStringVoltage },
    { header: 'Temperature', key: 'temperature', width: wchtemperature },
    { header: 'OutputCurrent1', key: 'outputCurrent1', width: wchoutputCurrent1 },
    { header: 'OutputCurrent2', key: 'outputCurrent2', width: wchoutputCurrent2 },
    { header: 'InverterStatus', key: 'inverterStatus', width: wchinverterStatus },
    { header: 'FrequencyOut', key: 'frequencyOut', width: wchfrequencyOut },
    { header: 'BatteryBreakerTripped', key: 'batteryBreakerTripped', width: wchbatteryBreakerTripped },
    { header: 'BatteryTimeMins', key: 'batteryTimeMins', width: wchbatteryTimeMins },
    { header: 'PowerSupplyRevision', key: 'powerSupplyRevision', width: wchpowerSupplyRevision },
    { header: 'TransponderRevision', key: 'transponderRevision', width: wchtransponderRevision },
    { header: 'TransponderFirmware', key: 'transponderFirmware', width: wchtransponderFirmware },
    { header: 'TransponderBootFile', key: 'transponderBootFile', width: wchtransponderBootFile },
    { header: 'CableModemBootFile', key: 'cableModemBootFile', width: wchcableModemBootFile },
    { header: 'PsSoftwareVersion', key: 'psSoftwareVersion', width: wchpsSoftwareVersion },
    { header: 'GeneratorSoftwareVersion', key: 'generatorSoftwareVersion', width: wchgeneratorSoftwareVersion },
    { header: 'Xm3SoftwareVersion', key: 'xm3SoftwareVersion', width: wchxm3SoftwareVersion },
    { header: 'Xm3SagCardFirmware', key: 'xm3SagCardFirmware', width: wchxm3SagCardFirmware },
    { header: 'Xm3AppCardFirmware', key: 'xm3AppCardFirmware', width: wchxm3AppCardFirmware },
    { header: 'AlphaPMCertificationReportLegacy', key: 'alphaPMCertificationReportLegacy', width: wchalphaPMCertificationReportLegacy },
    { header: 'TestStartStringVoltage', key: 'testStartStringVoltage', width: wchtestStartStringVoltage },
    { header: 'TestEndStringVoltage', key: 'testEndStringVoltage', width:wchtestEndStringVoltage },
    { header: 'OutputPower', key: 'powerOut', width: wchoutputPower },
    { header: 'String1Battery1Voltage', key: 's1b1Voltage', width: wchs1b1Voltage },
    { header: 'String1Battery2Voltage', key: 's1b2Voltage', width: wchs1b2Voltage },
    { header: 'String1Battery3Voltage', key: 's1b3Voltage', width: wchs1b3Voltage },
    { header: 'String1Battery4Voltage', key: 's1b4Voltage', width: wchs1b4Voltage },
    { header: 'String2Battery1Voltage', key: 's2b1Voltage', width: wchs2b1Voltage },
    { header: 'String2Battery2Voltage', key: 's2b2Voltage', width: wchs2b2Voltage },
    { header: 'String2Battery3Voltage', key: 's2b3Voltage', width: wchs2b3Voltage },
    { header: 'String2Battery4Voltage', key: 's2b4Voltage', width: wchs2b4Voltage },
    { header: 'String3Battery1Voltage', key: 's3b1Voltage', width: wchs3b1Voltage },
    { header: 'String3Battery2Voltage', key: 's3b2Voltage', width: wchs3b2Voltage },
    { header: 'String3Battery3Voltage', key: 's3b3Voltage', width: wchs3b3Voltage },
    { header: 'String3Battery4Voltage', key: 's3b4Voltage', width: wchs3b4Voltage },
    { header: 'String4Battery1Voltage', key: 's4b1Voltage', width: wchs4b1Voltage },
    { header: 'String4Battery2Voltage', key: 's4b2Voltage', width: wchs4b2Voltage },
    { header: 'String4Battery3Voltage', key: 's4b3Voltage', width: wchs4b3Voltage },
    { header: 'String4Battery4Voltage', key: 's4b4Voltage', width: wchs4b4Voltage },
  ];

    const lastvistarr =  [{ header: 'InspectionDate', key: 'inspectionDate', width: wchinspectionDate },
    { header: 'TypeOfVisit', key: 'typeOfVisit', width: wchtypeOfVisit },
    { header: 'XocVerified', key: 'xocVerified', width: wchxocVerified },
    { header: 'CleanEnclosure', key: 'cleanEnclosure', width: wchcleanEnclosure },
    { header: 'TightenHardware', key: 'tightenHardware', width: wchtightenHardware },
    { header: 'InspectConnectors', key: 'inspectConnectors', width: wchinspectConnectors },
    { header: 'InspectProbes', key: 'inspectProbes', width: wchinspectProbes },
    { header: 'meterPanCondition', key: 'meterPanCondition', width: wchmeterPanCondition },
    { header: 'PowerCoRiserCondition', key: 'powerCoRiserCondition', width: wchpowerCoRiserCondition },
    { header: 'BatteryHeaterMatType', key: 'batteryHeaterMatType', width: wchbatteryHeaterMatType },
    { header: 'BatteryHeaterMatQuantity', key: 'batteryHeaterMatQuantity', width: wchbatteryHeaterMatQuantity },
    { header: 'EnclosureSnowShield', key: 'enclosureSnowShield', width: wchenclosureSnowShield },
    { header: 'InternalBreaker', key: 'internalBreaker', width: wchinternalBreaker },
    { header: 'ServiceEntrance', key: 'serviceEntrance', width: wchserviceEntrance },
    { header: 'ReceptacleType', key: 'receptacleType', width: wchreceptacleType },
    { header: 'CheckSeizureAltBox', key: 'checkSeizureAltBox', width: wchcheckSeizureAltBox },
    { header: 'PowerSupplyIdLegible', key: 'powerSupplyIdLegible', width: wchpowerSupplyIdLegible },
    { header: 'CheckLampsLeds', key: 'checkLampsLeds', width: wchcheckLampsLeds },
    { header: 'CheckMagneticBreaker', key: 'checkMagneticBreaker', width: wchcheckMagneticBreaker },
    { header: 'VisualCabinetInspection', key: 'visualCabinetInspection', width: wchvisualCabinetInspection },
    { header: 'CabinetLocked', key: 'cabinetLocked', width: wchcabinetLocked },
    { header: 'SecurityBarPresent', key: 'securityBarPresent', width: wchsecurityBarPresent },
    { header: 'CheckGroundCabinet', key: 'checkGroundCabinet', width: wchcheckGroundCabinet },
    { header: 'BatteryString1Fused', key: 'batteryString1Fused', width: wchBatteryString1Fused },
    { header: 'BatteryString2Fused', key: 'batteryString2Fused', width: wchBatteryString2Fused },
    { header: 'BatteryString3Fused', key: 'batteryString3Fused', width: wchBatteryString3Fused },
    { header: 'BatteryString4Fused', key: 'batteryString4Fused', width: wchBatteryString4Fused },
    { header: 'TamperInstalledFunctioning', key: 'tamperInstalledFunctioning', width: wchtamperInstalledFunctioning },
    { header: 'CheckLaps', key: 'checkLaps', width: wchcheckLaps },
    { header: 'CabinetVendor', key: 'cabinetVendor', width: wchcabinetVendor },
    { header: 'CabinetBatteryCapacity', key: 'cabinetBatteryCapacity', width: wchcabinetBatteryCapacity },
    { header: 'CheckOperatingLights', key: 'checkOperatingLights', width: wchcheckOperatingLights },
    { header: 'StandByOperation', key: 'standByOperation', width: wchstandByOperation },
    { header: 'RemoteStandbyOperation2', key: 'remoteStandbyOperation2', width: wchremoteStandbyOperation2 },
    { header: 'RemoteStandbyOperation3', key: 'remoteStandbyOperation3', width: wchremoteStandbyOperation3 },
    { header: 'RemoteStandbyOperation4', key: 'remoteStandbyOperation4', width: wchremoteStandbyOperation4 },
    { header: 'RemoteStandbyOperation5', key: 'remoteStandbyOperation5', width: wchremoteStandbyOperation5 },
    { header: 'FollowUpNeeded', key: 'followUpNeeded', width: wchfollowUpNeeded },
    { header: 'InputSurgeArrestor', key: 'inputSurgeArrestor', width: wchinputSurgeArrestor },
    { header: 'OutputSurgeArrestor', key: 'outputSurgeArrestor', width: wchoutputSurgeArrestor },
    { header: 'CoaxTvssPresent', key: 'coaxTvssPresent', width: wchcoaxTvssPresent },
    { header: 'AcIndicatorGreenLight', key: 'acIndicatorGreenLight', width: wchacIndicatorGreenLight },
    { header: 'LocalRemoteIndicator', key: 'localRemoteIndicator', width: wchlocalRemoteIndicator },
    { header: 'CommTech', key: 'commTech', width: wchcommTech },
    { header: 'FollowUpReason', key: 'followUpReason', width: wchFollowUpReason },
    { header: 'VisitStatus', key: 'visitStatus', width: wchVisitStatus }];

    const lastvisitadditional = [{ header: 'CommTech', key: 'commTech', width: wchcommTech },
    { header: 'TypeOfVisit', key: 'typeOfVisit', width: wchtypeOfVisit },
    { header: 'InspectProbes', key: 'inspectProbes', width: wchinspectProbes },
    { header: 'CabinetVendor', key: 'cabinetVendor', width: wchcabinetVendor },
    { header: 'CabinetBatteryCapacity', key: 'cabinetBatteryCapacity', width: wchcabinetBatteryCapacity }];

    const batteryarr =  [{ header: 'BatteryReplacementDate', key: 'batteryReplacementDate', width: wchbatteryReplacementDate },
    { header: 'DateEntered', key: 'dateEntered', width: wchdateEntered },
    { header: 'Temperatures', key: 'temperatures', width: wchtemperatures },
    { header: 'SpecialLocationDetails', key: 'specialLocationDetails', width: wchspecialLocationDetails },
    { header: 'ShowActualLocation', key: 'showActualLocation', width: wchshowActualLocation },
    { header: 'Type11', key: 'type11', width: wchtype11 },
    { header: 'Type12', key: 'type12', width: wchtype12 },
    { header: 'Type13', key: 'type13', width: wchtype13 },
    { header: 'Type14', key: 'type14', width: wchtype14 },
    { header: 'Type21', key: 'type21', width: wchtype21 },
    { header: 'Type22', key: 'type22', width: wchtype22 },
    { header: 'Type23', key: 'type23', width: wchtype23 },
    { header: 'Type24', key: 'type24', width: wchtype24 },
    { header: 'Type31', key: 'type31', width: wchtype31 },
    { header: 'Type32', key: 'type32', width: wchtype32 },
    { header: 'Type33', key: 'type33', width: wchtype33 },
    { header: 'Type34', key: 'type34', width: wchtype34 },
    { header: 'String1Battery1DateCode', key: 'string1Battery1DateCode', width: wchstring1Battery1DateCode },
    { header: 'String1Battery2DateCode', key: 'string1Battery2DateCode', width: wchstring1Battery2DateCode },
    { header: 'String1Battery3DateCode', key: 'string1Battery3DateCode', width: wchstring1Battery3DateCode },
    { header: 'String1Battery4DateCode', key: 'string1Battery4DateCode', width: wchstring1Battery4DateCode },
    { header: 'String2Battery1DateCode', key: 'string2Battery1DateCode', width: wchstring2Battery1DateCode },
    { header: 'String2Battery2DateCode', key: 'string2Battery2DateCode', width: wchstring2Battery2DateCode },
    { header: 'String2Battery3DateCode', key: 'string2Battery3DateCode', width: wchstring2Battery3DateCode },
    { header: 'String2Battery4DateCode', key: 'string2Battery4DateCode', width: wchstring2Battery4DateCode },
    { header: 'String3Battery1DateCode', key: 'string3Battery1DateCode', width: wchstring3Battery1DateCode },
    { header: 'String3Battery2DateCode', key: 'string3Battery2DateCode', width: wchstring3Battery2DateCode },
    { header: 'String3Battery3DateCode', key: 'string3Battery3DateCode', width: wchstring3Battery3DateCode },
    { header: 'String3Battery4DateCode', key: 'string3Battery4DateCode', width: wchstring3Battery4DateCode },
    { header: 'InstallDate11', key: 'installDate11', width: wchinstallDate11 },
    { header: 'InstallDate12', key: 'installDate12', width: wchinstallDate12 },
    { header: 'InstallDate13', key: 'installDate13', width: wchinstallDate13 },
    { header: 'InstallDate14', key: 'installDate14', width: wchinstallDate14 },
    { header: 'InstallDate21', key: 'installDate21', width: wchinstallDate21 },
    { header: 'InstallDate22', key: 'installDate22', width: wchinstallDate22 },
    { header: 'InstallDate23', key: 'installDate23', width: wchinstallDate23 },
    { header: 'InstallDate24', key: 'installDate24', width: wchinstallDate24 },
    { header: 'InstallDate31', key: 'installDate31', width: wchinstallDate31 },
    { header: 'InstallDate32', key: 'installDate32', width: wchinstallDate32 },
    { header: 'InstallDate33', key: 'installDate33', width: wchinstallDate33 },
    { header: 'InstallDate34', key: 'installDate34', width: wchinstallDate34 },
    { header: 'Voltage11', key: 'voltage11', width: wchvoltage11 },
    { header: 'Voltage12', key: 'voltage12', width: wchvoltage12 },
    { header: 'Voltage13', key: 'voltage13', width: wchvoltage13 },
    { header: 'Voltage14', key: 'voltage14', width: wchvoltage14 },
    { header: 'Voltage21', key: 'voltage21', width: wchvoltage21 },
    { header: 'Voltage22', key: 'voltage22', width: wchvoltage22 },
    { header: 'Voltage23', key: 'voltage23', width: wchvoltage23 },
    { header: 'Voltage24', key: 'voltage24', width: wchvoltage24 },
    { header: 'Voltage31', key: 'voltage31', width: wchvoltage31 },
    { header: 'Voltage32', key: 'voltage32', width: wchvoltage32 },
    { header: 'Voltage33', key: 'voltage33', width: wchvoltage33 },
    { header: 'Voltage34', key: 'voltage34', width: wchvoltage34 }];



    //Condition based UI Dispaly
    if (telemetryDataVal == false && inspectionDataVal == false && batteryDataVal == false) {
      //only mandatory fields not telemetry,last visit info,battery
      return mandatoryarr
    }
    else if (telemetryDataVal == true && inspectionDataVal == false && batteryDataVal == false) {
      //mandatory + telemetry
      const mergedarr = mandatoryarr.concat(telemetryarr);
      return mergedarr;
    }
    else if (telemetryDataVal == false && inspectionDataVal == true && batteryDataVal == false) {
      //mandatory + last visit info
      const mergedarr = mandatoryarr.concat(lastvistarr);
      return mergedarr;
    }
    else if (telemetryDataVal == false && inspectionDataVal == false && batteryDataVal == true) {
      //mandatory + battery
      const mergedarr = mandatoryarr.concat(batteryarr);
      return mergedarr;
    }
    else if (telemetryDataVal == true && inspectionDataVal == true && batteryDataVal == false) {
      //mandatory + telemetry+lastvisit
      const mergedarr = mandatoryarr.concat(telemetryarr,lastvistarr);
      return mergedarr;
    }
    else if (telemetryDataVal == false && inspectionDataVal == true && batteryDataVal == true) {
      //mandatory + lastvisit + battery
      const mergedarr = mandatoryarr.concat(lastvistarr,batteryarr);
      return mergedarr;
    }
    else if (telemetryDataVal == true && inspectionDataVal == false && batteryDataVal == true) {
      //mandatory + telemetry + battery
      //Here adding 5 inspection data fields additional as per requirements
      const mergedarr = mandatoryarr.concat(telemetryarr,batteryarr,lastvisitadditional);
      return mergedarr;
    }
    else {
      //mandatory + telemetry + last visit info + battery
      const mergedarr = mandatoryarr.concat(telemetryarr,lastvistarr,batteryarr);
      return mergedarr;

    }



  }
}



